// Admin - Dashbaord.

import React from 'react';
import Config from '../../lib/Config';
import Header from '../../lib-ui/admin/Header';
import UIString from '../../assets/content/UIString';
import { useEffect, useState } from 'react';
import IconButton from '@mui/material/IconButton';
import Input from '@mui/material/Input';
import FilledInput from '@mui/material/FilledInput';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Button } from '@mui/material';
import axios from 'axios';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavBar from '../../lib-ui/admin/NavBar';
import Alert from '@mui/material/Alert';
import Util from '../../lib/Util';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
// import { useNavigate } from 'react-router-dom';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AppleIcon from '@mui/icons-material/Apple';
import AndroidIcon from '@mui/icons-material/Android';
import Chip from '@mui/material/Chip';
import LinkIcon from '@mui/icons-material/Link';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import Brightness1Icon from '@mui/icons-material/Brightness1';
import Block1Icon from '@mui/icons-material/Block';
import IOSSwitch from '../../lib-ui/common/IOSSwitch';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
//import IconButton from '@mui/material/IconButton';
import CancelIcon from '@mui/icons-material/Cancel';
import CloseIcon from '@mui/icons-material/Close';
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';
import Pagination from '@mui/material/Pagination';
import PagePanel from '../../lib-ui/common/PagePanel';
import SearchBar from '../../lib-ui/admin/SearchBar';
import { useSearchParams, useParams } from 'react-router-dom';
import Divider from '@mui/material/Divider';
import '../../assets/style/common.css';
import '../../assets/style/admin.css';



const lang = Util.get_lang();

export default () => {

    // const navigate = useNavigate();


    const params = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    const [navTitle, setNavTitle] = useState('');
    const [flagContent, setFlagContent] = useState('');
    const [flagToast, setFlagToast] = useState(false);
    const [toastMsg, setToastMsg] = useState();
    const [toastModeIcon, setToastModeIcon] = useState();
    const closeToast = () => { flagToast ? setFlagToast(false) : setFlagToast(true); }
    const showToast = (mode, msg) => {
        switch (mode) {
            case 'info': setToastModeIcon(<InfoIcon sx={{ fontSize: '32px', color: '#66ff66' }} />); break;
            case 'warning': setToastModeIcon(<WarningIcon sx={{ fontSize: '18px', color: '#6666ff' }} />); break;
        }

        setToastMsg(msg);
        setFlagToast(true);
    }
    const [detail, setDetail] = useState({});
    const [userSessions, setUserSessions] = useState([]);
    const [flagUserSessionEdit, setFlagUserSessionEdit] = useState([]);

    const [flagStatus, setFlagStatus] = useState('none');
    const [flagNote, setFlagNote] = useState('none');

    const [detailNote, setDetailNote] = useState('');







    const [keyword, setKeyword] = useState('');
    const [userListData, setUserListData] = useState({ current_page: 0, pages: [], prev_section: false, next_section: false });
    const [userList, setUserList] = useState([]);
    const [sessionDetailArray, setSessionDetailArray] = useState([]);
    const [flagDataDetail, setFlagDataDetail] = useState('none');
    const [flagSessDetail, setFlagSessDetail] = useState([]);
    const [profileImage, setProfileImage] = useState('/ko/api/v1/admin/user/app-session/profile_image/0/default.png');





    useEffect(() => {

        setNavTitle([UIString[lang]['NAV_USER'], UIString[lang]['NAV_DETAIL']]);
        load_detail(params.id);
        load_user_sessions(params.id);

    }, []);






    function toggle_detail(idx) {

        let t_array = [];

        for (let i = 0; i < flagSessDetail.length; i++) {

            let t_flag = flagSessDetail[i];

            if (i == idx) {
                if (t_flag == 'none') {
                    t_flag = '';
                    update_session_detail_flag(userList[idx].id, true);
                } else {
                    t_flag = 'none';
                    update_session_detail_flag(userList[idx].id, false);
                }
            }

            t_array[i] = t_flag;
        }

        setFlagSessDetail(t_array);
    }






    function update_session_detail_flag(sess_id, flag) {

        let t_array = [];


        if (flag) {
            // Add.

            let flag_exists = false;
            for (let i = 0; i < sessionDetailArray.length; i++) {
                if (sessionDetailArray[i] == sess_id) {
                    flag_exists = true;
                }

                t_array.push(sessionDetailArray[i]);
            }

            if (!flag_exists) { t_array.push(sess_id); }

        } else {
            // Remove.

            for (let i = 0; i < sessionDetailArray.length; i++) {
                if (sessionDetailArray[i] != sess_id) {
                    t_array.push(sessionDetailArray[i]);
                }
            }

        }

        setSessionDetailArray(t_array);
    }













    function update_user_detail(id, col, val) {

        const form = {
            name: col,
            value: val
        }

        Util.post(
            '/' + lang + '/api/v1/admin/user/update/' + id,
            form,
            (data) => {
                showToast('info', UIString[lang]['UPDATED']);
                //load_session_list();
                load_detail(detail.id);
            },
            (error) => {
                //  return: {type,msg}
                document.location.href = '/admin/login';
                showToast(UIString[lang]['UPDATE_FAILED']);
            }
        );
    }


    function update_user_session(id, col, val) {

        const form = {
            name: col,
            value: val
        }

        Util.post(
            '/' + lang + '/api/v1/admin/user/app-session/update/' + id,
            form,
            (data) => {
                showToast('info', UIString[lang]['UPDATED']);
                //load_session_list();
                load_user_sessions(params.id);
            },
            (error) => {
                //  return: {type,msg}
                document.location.href = '/admin/login';
                showToast(UIString[lang]['UPDATE_FAILED']);
            }
        );
    }





    function load_detail(detail_id) {

        let url = '/' + lang + '/api/v1/admin/user/detail/' + detail_id;

        // Get data.
        let form = new FormData;
        Util.get(
            url,
            (data) => {


                /*

                for (let i = 0; i < data.list.length; i++) {
                    let sess_item = data.list[i];

                    switch (sess_item.status) {
                        case 'ACTIVE': sess_item.status_chip = <Chip label="ACTIVE" color="#ffcc00" size='small' sx={{ width: '80px', fontSize: '11px', backgroundColor: '#99ff00', color: '#222222' }} />; break;
                        case 'INACTIVE': sess_item.status_chip = <Chip label="INACTIVE" color="#ffcc00" size='small' sx={{ width: '80px', fontSize: '11px', backgroundColor: '#a5a5a5', color: '#ffffff' }} />; break;
                        case 'DELETED': sess_item.status_chip = <Chip label="DELETED" color="#ffcc00" size='small' sx={{ width: '80px', fontSize: '11px', backgroundColor: '#222222', color: '#ffffff' }} />; break;
                        default: sess_item.status_chip = <Chip label="DEFAULT" color="#ffcc00" size='small' sx={{ width: '80px', fontSize: '11px', backgroundColor: '#00ff00', color: '#222222' }} />; break;
                    }

                    sess_item.disp = 'none';

                    sess_array.push(sess_item);
                    sess_detail_array.push('none');

                }
                setUserList(sess_array);
                setFlagSessDetail(sess_detail_array);
                setUserListData({
                    prev_section: data.prev_section,
                    current_page: data.current_page,
                    next_section: data.next_section,
                    pages: data.pages
                });

                if (sess_array.length == 0) { setFlagContent('none'); } else { setFlagContent(''); }
                */

                console.log('detail loaded', data);
                setDetailNote(data.note);

                if (String(data.note).length >= 60) { data.note = String(data.note).substr(0, 60) + '...'; }

                setDetail(data);



            },
            (err) => {
                alert(err + '336');
            }
        );
    }




    function load_user_sessions(detail_id) {

        let url = '/' + lang + '/api/v1/admin/user/' + detail_id + '/app-sessions';

        // Get data.
        let form = new FormData;
        Util.get(
            url,
            (data) => {


                /*

                for (let i = 0; i < data.list.length; i++) {
                    let sess_item = data.list[i];

                    switch (sess_item.status) {
                        case 'ACTIVE': sess_item.status_chip = <Chip label="ACTIVE" color="#ffcc00" size='small' sx={{ width: '80px', fontSize: '11px', backgroundColor: '#99ff00', color: '#222222' }} />; break;
                        case 'INACTIVE': sess_item.status_chip = <Chip label="INACTIVE" color="#ffcc00" size='small' sx={{ width: '80px', fontSize: '11px', backgroundColor: '#a5a5a5', color: '#ffffff' }} />; break;
                        case 'DELETED': sess_item.status_chip = <Chip label="DELETED" color="#ffcc00" size='small' sx={{ width: '80px', fontSize: '11px', backgroundColor: '#222222', color: '#ffffff' }} />; break;
                        default: sess_item.status_chip = <Chip label="DEFAULT" color="#ffcc00" size='small' sx={{ width: '80px', fontSize: '11px', backgroundColor: '#00ff00', color: '#222222' }} />; break;
                    }

                    sess_item.disp = 'none';

                    sess_array.push(sess_item);
                    sess_detail_array.push('none');

                }
                setUserList(sess_array);
                setFlagSessDetail(sess_detail_array);
                setUserListData({
                    prev_section: data.prev_section,
                    current_page: data.current_page,
                    next_section: data.next_section,
                    pages: data.pages
                });

                if (sess_array.length == 0) { setFlagContent('none'); } else { setFlagContent(''); }
                */

                console.log('session loaded', data);
                //setDetailNote(data.note);

                //if( String(data.note).length >= 60 ){data.note = String(data.note).substr(0,60)+'...';}
                if (userSessions.length == 0) { 
                    
                    let t_flags = [];
                  
                    for( let i=0;i<data.length;i++ ){
                    
                        t_flags.push({
                            index:i,
                            is_logged_in:'none',
                            status:'none'
                        });
                    }

                    setFlagUserSessionEdit(t_flags);
                }
                setUserSessions(data);



            },
            (err) => {
                alert(err + '336');
            }
        );
    }


    function toggle_user_session_edit(idx,t_is_logged_in,t_status){
        
        let t = [];

        for(let i=0;i<flagUserSessionEdit.length;i++){

            if( idx == flagUserSessionEdit[i].index ){

                let t_item = {};
                t_item.index = flagUserSessionEdit[i].index;
                t_item.status = flagUserSessionEdit[i].status;
                t_item.is_logged_in = flagUserSessionEdit[i].is_logged_in;

                if( t_is_logged_in != null ){
                    t_item.is_logged_in == '' ? t_item.is_logged_in = 'none' : t_item.is_logged_in = '';
                }

                if( t_status != null ){
                    t_item.status == '' ?  t_item.status = 'none' : t_item.status = '';
                }

                t.push(t_item);

            }else{
                t.push({
                    index:flagUserSessionEdit[i].index,
                    is_logged_in:flagUserSessionEdit[i].is_logged_in,
                    status:flagUserSessionEdit[i].status
                });
            }

        }
        setFlagUserSessionEdit(t);
    }





    return (
        <>
            <Header code={'user'} />
            <div style={{ width: '1000px', height: '100%', minHeight: '600px', paddingTop: '60px', textAlign: 'center', backgroundColor: '#ffffff', margin: '0px auto' }}>
                <Stack  className='page_title'  direction={'col'}>
                    <NavBar text={navTitle} key={navTitle} />
                    <span className='nav_right_button' onClick={()=>{window.history.back()}}>{UIString[lang]['BACK']}</span>
                </Stack>
                <Paper elevation={0} sx={{ padding: '2px', textAlign: 'left', fontSize: '13px', marginBottom: '38px', display: `${flagContent}` }}>
                    <br />

                    <Stack direction="row" sx={{ width: "100%" }}>
                        <div style={{ flexGrow: 1 }}>
                            {/*<div style={{ height: '36px', fontSize: '13px', color: '#222222' }}>{UIString[lang]['USER']}</div>*/}
                            <div className={'section_title'}>◼&nbsp;&nbsp;{UIString[lang]['USER']}</div>
                            <Divider sx={{ paddingLeft: '0px', '&::before': { width: 0 }, }} textAlign="left" />
                            <table style={{ width: '100%', border: 'none', borderCollapse: 'collapse' }}>
                                <tr className='data_cell'>
                                    <td class={'user_detail_label_cell'}>ID</td>
                                    <td class={'user_detail_data_cell'}>{detail.id}</td>
                                    <td class={'user_detail_right_cell'}>&nbsp;&nbsp;</td>
                                </tr>
                                <tr className='data_cell'>
                                    <td class={'user_detail_label_cell'}>Link ID</td>
                                    <td class={'user_detail_data_cell'}>{detail.link_id}</td>
                                    <td class={'user_detail_right_cell'}>&nbsp;&nbsp;</td>
                                </tr>
                                <tr className='data_cell'>
                                    <td class={'user_detail_label_cell'}>Profile Image</td>
                                    <td class={'user_detail_data_cell'}>
                                        <div style={{ width: '60px', height: '60px', overflow: 'hidden', borderRadius: '50%', backgroundColor: 'white' }}>
                                            <img style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', backgroundColor: '#fffff' }} src={`${profileImage}`} />
                                        </div>
                                    </td>
                                    <td class={'user_detail_right_cell'}>&nbsp;&nbsp;</td>
                                </tr>
                                <tr className='data_cell'>
                                    <td class={'user_detail_label_cell'}>Name</td>
                                    <td class={'user_detail_data_cell'}>{detail.name}</td>
                                    <td class={'user_detail_right_cell'}>&nbsp;&nbsp;</td>
                                </tr>
                                <tr className='data_cell'>
                                    <td class={'user_detail_label_cell'}>Name (English)</td>
                                    <td class={'user_detail_data_cell'}>{detail.en_name}</td>
                                    <td class={'user_detail_right_cell'}>&nbsp;&nbsp;</td>
                                </tr>
                                <tr className='data_cell'>
                                    <td class={'user_detail_label_cell'}>EMail</td>
                                    <td class={'user_detail_data_cell'}>{detail.email}</td>
                                    <td class={'user_detail_right_cell'}>&nbsp;&nbsp;</td>
                                </tr>
                                <tr className='data_cell'>
                                    <td class={'user_detail_label_cell'}>Country</td>
                                    <td class={'user_detail_data_cell'}>{detail.country}</td>
                                    <td class={'user_detail_right_cell'}>&nbsp;&nbsp;</td>
                                </tr>
                                <tr className='data_cell'>
                                    <td class={'user_detail_label_cell'}>Gender</td>
                                    <td class={'user_detail_data_cell'}>{detail.gender}</td>
                                    <td class={'user_detail_right_cell'}>&nbsp;&nbsp;</td>
                                </tr>
                                <tr className='data_cell'>
                                    <td class={'user_detail_label_cell'}>Year of Birth</td>
                                    <td class={'user_detail_data_cell'}>{detail.year_of_birth}</td>
                                    <td class={'user_detail_right_cell'}>&nbsp;&nbsp;</td>
                                </tr>
                                <tr className='data_cell'>
                                    <td class={'user_detail_label_cell'}>Mobile Nunmber</td>
                                    <td class={'user_detail_data_cell'}>{detail.mobile_number}</td>
                                    <td class={'user_detail_right_cell'}>&nbsp;&nbsp;</td>
                                </tr>
                                <tr className='data_cell'>
                                    <td class={'user_detail_label_cell'}>Created</td>
                                    <td class={'user_detail_data_cell'}>{detail.created} / {detail.created_utc}</td>
                                </tr>
                                <tr className='data_cell'>
                                    <td class={'user_detail_label_cell'}>Updated</td>
                                    <td class={'user_detail_data_cell'}>{detail.updated} / {detail.updated_utc}</td>
                                </tr>
                                <tr className='data_cell'>
                                    <td class={'user_detail_label_cell'}>Status</td>
                                    <td class={'user_detail_data_cell'}>{detail.status}</td>
                                    <td class={'user_detail_right_cell'}  style={{cursor:'pointer'}} onClick={() => { flagStatus == '' ? setFlagStatus('none') : setFlagStatus('') }}>{UIString[lang]['EDIT']}</td>
                                </tr>
                                <tr style={{ display: flagStatus }}>
                                    <td class={'user_detail_label_cell'}>&nbsp;&nbsp;</td>
                                    <td class={'user_detail_data_cell'}>
                                        <Select
                                            key={detail.status}
                                            labelId="demo-select-small-label"
                                            id="demo-select-small"
                                            value={String(detail.status)}
                                            onChange={(t) => { update_user_detail(detail.id, 'status', t.target.value) }}
                                            size='small'
                                            sx={{
                                                height: '34px', fontSize: '13px',
                                                backgroundColor: '#f8f8f8',
                                                '& .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: '#a0a0a0', // Default border color
                                                    borderWidth: '0px',
                                                    borderCollapse: 'collapse',

                                                },
                                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: '#a0a0a0', // Border color when focused
                                                    borderWidth: '0px',
                                                    borderCollapse: 'collapse',
                                                },
                                            }}
                                        >
                                            <MenuItem sx={{ fontSize: '13px' }} value={'ACTIVE'}>ACTIVE</MenuItem>
                                            <MenuItem sx={{ fontSize: '13px' }} value={'INACTIVE'}>INACTIVE</MenuItem>
                                            <MenuItem sx={{ fontSize: '13px' }} value={'DELETED'}>DELETED</MenuItem>
                                        </Select>
                                    </td>
                                    <td>&nbsp;&nbsp;</td>
                                </tr>
                                <tr className='data_cell'>
                                    <td class={'user_detail_label_cell'}>Note</td>
                                    <td class={'user_detail_data_cell'}>{detail.note}</td>
                                    <td class={'user_detail_right_cell'}  style={{cursor:'pointer'}} onClick={() => { if (flagNote == '') { setFlagNote('none'); load_detail(params.id) } else { setFlagNote('') } }}>{UIString[lang]['EDIT']}</td>
                                </tr>
                                <tr style={{ display: flagNote }}>
                                    <td class={'user_detail_label_cell'}>&nbsp;&nbsp;</td>
                                    <td class={'user_detail_data_cell'}>
                                        <TextField
                                            variant='outlined'
                                            multiline
                                            rows={4}
                                            value={detailNote}
                                            onChange={(t) => { if (t.target.value.length >= 200) { setDetailNote(String(t.target.value).substr(0, 200)); } else { setDetailNote(t.target.value); } }}
                                            sx={{
                                                width: '100%',
                                                '& .MuiOutlinedInput-root': {
                                                    '&.Mui-focused fieldset': {
                                                        borderColor: '#a0a0a0', // Change the border color when focused
                                                        borderWidth: '0px',
                                                        borderCollapse: 'collapse',
                                                        // backgroundColor:'#f2f2f2',

                                                    },
                                                },

                                                '& .MuiOutlinedInput-notchedOutline': {
                                                    border: 'none', // Removes the border
                                                    // backgroundColor:'#f2f2f2',
                                                },
                                                '& .MuiOutlinedInput-root': {
                                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                                        border: 'none', // Removes the border on hover
                                                        //backgroundColor:'#f2f2f2',
                                                    },
                                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                        border: 'none', // Removes the border on focus
                                                        //backgroundColor:'#f2f2f2',
                                                    },
                                                }
                                            }}

                                            InputProps={{
                                                style: { fontSize: '13px', color: '#222222', backgroundColor: '#f8f8f8' }, // Change input font size
                                            }}
                                        />
                                    </td>
                                    <td class={'user_detail_right_cell'} style={{cursor:'pointer'}} onClick={() => { update_user_detail(detail.id, 'note', detailNote) }}>{UIString[lang]['UPDATE']}</td>
                                </tr>
                            </table>
                            <br /><br />
                            <div className='section_title'>◼&nbsp;&nbsp;{UIString[lang]['APP_SESSIONS']}</div>
                            <Divider sx={{ paddingLeft: '0px', '&::before': { width: 0 }, }} textAlign="left" /><br />

                            {userSessions.map((item, index) => <><table style={{ width: '100%', border: 'none', borderCollapse: 'collapse' }}>
                                <tr className='data_cell'>
                                    <td class={'user_detail_label_cell'}>ID</td>
                                    <td class={'user_detail_data_cell'}>{item.id}</td>
                                    <td class={'user_detail_right_cell'}>&nbsp;&nbsp;</td>
                                </tr>
                                <tr className='data_cell'>
                                    <td class={'user_detail_label_cell'}>Session Key</td>
                                    <td class={'user_detail_data_cell'}>{item.session_key}</td>
                                    <td class={'user_detail_right_cell'}>&nbsp;&nbsp;</td>
                                </tr>
                                <tr className='data_cell'>
                                    <td class={'user_detail_label_cell'}>Device Type</td>
                                    <td class={'user_detail_data_cell'}>{item.device_type}</td>
                                    <td class={'user_detail_right_cell'}>&nbsp;&nbsp;</td>
                                </tr>
                                <tr className='data_cell'>
                                    <td class={'user_detail_label_cell'}>Device OS</td>
                                    <td class={'user_detail_data_cell'}>{item.device_os}</td>
                                    <td class={'user_detail_right_cell'}>&nbsp;&nbsp;</td>
                                </tr>
                                <tr className='data_cell'>
                                    <td class={'user_detail_label_cell'}>Device UID</td>
                                    <td class={'user_detail_data_cell'}>{item.device_uid}</td>
                                    <td class={'user_detail_right_cell'}>&nbsp;&nbsp;</td>
                                </tr>
                                <tr className='data_cell'>
                                    <td class={'user_detail_label_cell'}>Is logged in</td>
                                    <td class={'user_detail_data_cell'}>{item.is_logged_in == 1 ? 'YES' : 'NO'}</td>
                                    <td class={'user_detail_right_cell'} style={{cursor:'pointer'}} onClick={()=>{toggle_user_session_edit(index,1,null)}}>{UIString[lang]['EDIT']}</td>
                                </tr>
                                <tr className='data_cell' style={{display:`${flagUserSessionEdit[index].is_logged_in}`}}>
                                    <td class={'user_detail_label_cell'}>&nbsp;&nbsp;</td>
                                    <td class={'user_detail_data_cell'}> 
                                        <Select
                                            key={item.is_logged_in}
                                            labelId="demo-select-small-label"
                                            id="demo-select-small"
                                            value={item.is_logged_in}
                                            onChange={(t) => { update_user_session(item.id, 'is_logged_in', t.target.value) }}
                                            size='small'
                                            sx={{
                                                height: '34px', fontSize: '13px',
                                                backgroundColor: '#f8f8f8',
                                                '& .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: '#a0a0a0', // Default border color
                                                    borderWidth: '0px',
                                                    borderCollapse: 'collapse',

                                                },
                                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: '#a0a0a0', // Border color when focused
                                                    borderWidth: '0px',
                                                    borderCollapse: 'collapse',
                                                },
                                            }}
                                        >
                                            <MenuItem sx={{ fontSize: '13px' }} value={1}>YES (Logged in)</MenuItem>
                                            <MenuItem sx={{ fontSize: '13px' }} value={0}>NO (Logged out)</MenuItem>
                                        </Select></td>
                                    <td class={'user_detail_right_cell'}>&nbsp;&nbsp;</td>
                                </tr>
                                <tr className='data_cell'>
                                    <td class={'user_detail_label_cell'}>Login Time</td>
                                    <td class={'user_detail_data_cell'}>{item.login_time} / {item.login_utc_time}</td>
                                    <td class={'user_detail_right_cell'}>&nbsp;&nbsp;</td>
                                </tr>
                                <tr className='data_cell'>
                                    <td class={'user_detail_label_cell'}>Login IP</td>
                                    <td class={'user_detail_data_cell'}>{item.login_ip}</td>
                                    <td class={'user_detail_right_cell'}>&nbsp;&nbsp;</td>
                                </tr>
                                <tr className='data_cell'>
                                    <td class={'user_detail_label_cell'}>Status</td>
                                    <td class={'user_detail_data_cell'}>{item.status}</td>
                                    <td class={'user_detail_right_cell'} style={{cursor:'pointer'}} onClick={()=>{toggle_user_session_edit(index,null,1)}}>{UIString[lang]['EDIT']}</td>
                                </tr>
                                <tr className='data_cell' style={{display:`${flagUserSessionEdit[index].status}`}}>
                                    <td class={'user_detail_label_cell'}>&nbsp;&nbsp;</td>
                                    <td class={'user_detail_data_cell'}> 
                                        <Select
                                            key={item.status}
                                            labelId="demo-select-small-label"
                                            id="demo-select-small"
                                            value={String(item.status)}
                                            onChange={(t) => { update_user_session(item.id, 'status', t.target.value) }}
                                            size='small'
                                            sx={{
                                                height: '34px', fontSize: '13px',
                                                backgroundColor: '#f8f8f8',
                                                '& .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: '#a0a0a0', // Default border color
                                                    borderWidth: '0px',
                                                    borderCollapse: 'collapse',

                                                },
                                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: '#a0a0a0', // Border color when focused
                                                    borderWidth: '0px',
                                                    borderCollapse: 'collapse',
                                                },
                                            }}
                                        >
                                            <MenuItem sx={{ fontSize: '13px' }} value={'ACTIVE'}>ACTIVE</MenuItem>
                                            <MenuItem sx={{ fontSize: '13px' }} value={'INACTIVE'}>INACTIVE</MenuItem>
                                            <MenuItem sx={{ fontSize: '13px' }} value={'DELETED'}>DELETED</MenuItem>
                                        </Select></td>
                                    <td class={'user_detail_right_cell'}>&nbsp;&nbsp;</td>
                                </tr>
                                <tr className='data_cell'>
                                    <td class={'user_detail_label_cell'}>Created</td>
                                    <td class={'user_detail_data_cell'}>{item.created} / {item.created_utc}</td>
                                    <td class={'user_detail_right_cell'}>&nbsp;&nbsp;</td>
                                </tr>
                                <tr className='data_cell'>
                                    <td class={'user_detail_label_cell'}>Updated</td>
                                    <td class={'user_detail_data_cell'}>{item.created} / {item.updated_utc}</td>
                                    <td class={'user_detail_right_cell'}>&nbsp;&nbsp;</td>
                                </tr>
                            </table><br /></>)}
                        </div>
                        <br />

                    </Stack>
                
                    {/*<TableContainer component={Paper} sx={{}}>
                        <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                            <TableHead>
                                <TableRow sx={{ fontWeight: 'normal', fontSize: '13px', backgroundColor: '#f2f2f2' }}>
                                    <TableCell sx={{ fontWeight: 'normal', fontSize: '13px', width: '80px' }} align='right'>Id</TableCell>
                                    <TableCell sx={{ fontWeight: 'normal', fontSize: '13px', width: '200px' }} align="left">Email</TableCell>
                                    <TableCell sx={{ fontWeight: 'normal', fontSize: '13px', width: '180px' }} align="left">Name</TableCell>
                                    <TableCell sx={{ fontWeight: 'normal', fontSize: '13px', width: '180px' }} align="left">Name(EN)</TableCell>
                                    <TableCell sx={{ fontWeight: 'normal', fontSize: '13px', width: '130px' }} align="left">created</TableCell>
                                    <TableCell sx={{ fontWeight: 'normal', fontSize: '13px', width: '130px' }} align="left">created (UTC)</TableCell>
                                    <TableCell sx={{ fontWeight: 'normal', fontSize: '13px', width: '100px' }} align="center">Status</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {userList.map((item, index) => <><TableRow sx={{ fontWeight: 'normal', fontSize: '13px', backgroundColor: '#ffffff', cursor: 'pointer', "&:hover": { backgroundColor: '#f8f8f8' } }} onClick={() => { toggle_detail(index) }}>
                                    <TableCell sx={{ fontWeight: 'normal', fontSize: '13px' }} align='right'>{item.id}</TableCell>
                                    <TableCell sx={{ fontWeight: 'normal', fontSize: '13px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', wordBreak: 'break-all', maxWidth: '200px', whiteSpace: 'nowrap', overflow: 'hidden' }} textOverflow="ellipsis" align="left">{item.email}</TableCell>
                                    <TableCell sx={{ fontWeight: 'normal', fontSize: '13px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '180px', }} textOverflow="ellipsis" align="left">{item.name}</TableCell>
                                    <TableCell sx={{ fontWeight: 'normal', fontSize: '13px', width: '60px', maxWidth: '100px', }} textOverflow="ellipsis" >{item.en_name}</TableCell>
                                    <TableCell sx={{ fontWeight: 'normal', fontSize: '13px', textOverflow: 'ellipsis', maxWidth: '100px', whiteSpace: 'nowrap', overflow: 'hidden' }} align="left">{item.created != null ? item.created.substr(0, 10) : '?'}</TableCell>
                                    <TableCell sx={{ fontWeight: 'normal', fontSize: '13px', textOverflow: 'ellipsis', maxWidth: '100px', whiteSpace: 'nowrap', overflow: 'hidden' }} align="left" textOverflow="ellipsis">{item.created_utc != null ? item.created_utc.substr(0, 10) : '?'}</TableCell>
                                    <TableCell sx={{ fontWeight: 'normal', fontSize: '13px' }} align="left">{item.status_chip}</TableCell></TableRow></>)} */}
                    {/*rows.map((row) => (
                                    <TableRow
                                        key={row.name}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell component="th" scope="row">
                                            {row.name}
                                        </TableCell>
                                        <TableCell align="right">{row.calories}</TableCell>
                                        <TableCell align="right">{row.fat}</TableCell>
                                        <TableCell align="right">{row.carbs}</TableCell>
                                        <TableCell align="right">{row.protein}</TableCell>
                                    </TableRow>
                                ))}*/}


                    {/*<TableRow
                                    sx={{cursor:'pointer', '&:last-child td, &:last-child th': { border: 0 } }}
                                    onClick={()=>{ flagDataDetail == '' ? setFlagDataDetail('none') : setFlagDataDetail('') }}
                                >
                                    <TableCell component="th" scope="row">
                                    Gingerbread?
                                    </TableCell>
                                    <TableCell align="right">aaa</TableCell>
                                    <TableCell align="right">bbb</TableCell>
                                    <TableCell align="right">ccc</TableCell>
                                    <TableCell align="right">ddd</TableCell>
                                </TableRow>
                                <TableRow sx={{ display: `${flagDataDetail}` }}>
                                    <TableCell colSpan={5} sx={{ padding: '0px' }}>

                                        <Accordion sx={{ margin: '0px', width: '100%', elevation:'0',border:'none',boxShadow:'none',backgroundColor:'#f8f8f8' }}>
                                            <AccordionDetails sx={{ margin: '0px', elevation:'0',border:'none',boxShadow:'none' }}>
                                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
                                                malesuada lacus ex, sit amet blandit leo lobortis eget.
                                            </AccordionDetails>
                                        </Accordion>
                                    </TableCell>
                                </TableRow>
                                <TableRow

                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell component="th" scope="row">
                                    Gingerbread
                                    </TableCell>
                                    <TableCell align="right">aaa</TableCell>
                                    <TableCell align="right">bbb</TableCell>
                                    <TableCell align="right">ccc</TableCell>
                                    <TableCell align="right">ddd</TableCell>
                                </TableRow>

                                <TableRow

                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell component="th" scope="row">
                                    Gingerbread
                                    </TableCell>
                                    <TableCell align="right">aaa</TableCell>
                                    <TableCell align="right">bbb</TableCell>
                                    <TableCell align="right">ccc</TableCell>
                                    <TableCell align="right">ddd</TableCell>
                                </TableRow>*/}



                    {/*</TableBody>
                        </Table>
                    </TableContainer>*/}
                    <br />

                </Paper>

                {flagContent == 'none' ? <Box sx={{ width: '100%', height: '600px', textAlign: 'center', fontSize: '13px' }}>
                    <WarningIcon style={{ fontSize: '80px', marginTop: '180px', marginBottom: '22px' }} /><br />
                    {UIString[lang]['NO_DATA']}
                </Box> : <></>}

                <div style={{ height: '600px' }}>&nbsp;&nbsp;</div>
                <Snackbar
                    sx={{}}
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                    open={flagToast}
                    onClose={closeToast}
                    autoHideDuration={1800}
                    key={'top' + 'center'}
                >
                    <SnackbarContent
                        sx={{
                            backgroundColor: '#fcfcfc',
                            color: '#222222',
                            minHeight: '60px',
                            fontSize: '13px',
                            display: "flex",
                            justifyContent: "space-between", // Space between text and icon
                            alignItems: "center",
                        }}

                        message={<Box display="flex" alignItems="center">
                            {toastModeIcon}&nbsp;&nbsp;
                            <span>{toastMsg}</span>
                        </Box>}
                        action={
                            <IconButton
                                size="small"
                                color="inherit"
                                onClick={() => console.log("Close clicked")}
                            >
                                <CloseIcon sx={{ cursor: 'pointer', fontSize: '18px', color: '#222222' }} onClick={() => { closeToast() }} />
                            </IconButton>}

                    />
                </Snackbar>









            </div>
        </>
    );

}